import { render, staticRenderFns } from "./PerformanceBottom.vue?vue&type=template&id=7624b610&scoped=true&"
import script from "./PerformanceBottom.vue?vue&type=script&lang=js&"
export * from "./PerformanceBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7624b610",
  null
  
)

export default component.exports